import PropTypes from 'prop-types';
import {TripPropTypes} from "./TripPropTypes";
import {AccommodationPropTypes} from "./GuestsPropTypes";

export const BerthsPropTypes = PropTypes.arrayOf(PropTypes.shape({
    index: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    count: PropTypes.number,
}));

export const BedRoomInfoPropTypes = PropTypes.shape({
    roomInfoId: PropTypes.number,
    roomClassFk: PropTypes.number,
    tripTypeFk: PropTypes.number,
    shipFk: PropTypes.number,
    enabled: PropTypes.number,
    locationFk: PropTypes.number,
    seasonFk: PropTypes.number,
    heading: PropTypes.string,
    roomDescription: PropTypes.string,
    roomImages: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
});

export const BookingPropTypes = PropTypes.shape({
    id: PropTypes.number,
    changed: PropTypes.number,
    TripId: PropTypes.number,
    DealerId: PropTypes.number,
    userFkCreate: PropTypes.number,
    userFkEdit: PropTypes.number,
    commission: PropTypes.number,
    isCharter: PropTypes.number,
    rewardFk: PropTypes.number,
    rewardDays: PropTypes.number,
    doDiveAssure: PropTypes.number,
    bookStateFk: PropTypes.number,
    session: PropTypes.string,
    Type: PropTypes.number,
    bookSourceFk: PropTypes.number,
    bahiaOption: PropTypes.number,
    Confirmation: PropTypes.string,
    ConfirmSent: PropTypes.number,
    ConfirmDate: PropTypes.string,
    RetailPrice: PropTypes.number,
    InitialPrice: PropTypes.number,
    DealerPrice: PropTypes.number,
    TotalPaid: PropTypes.number,
    DateBooked: PropTypes.string,
    LastUpdate: PropTypes.string,
    EarlyBookDate: PropTypes.number,
    EarlyDiscount: PropTypes.number,
    ExecSingle: PropTypes.number,
    ExecDouble: PropTypes.number,
    ExecNonDiver: PropTypes.number,
    ExecShared: PropTypes.number,
    StateSingle: PropTypes.number,
    StateDouble: PropTypes.number,
    StateTriple: PropTypes.number,
    StateShared: PropTypes.number,
    StateNonDiver: PropTypes.number,
    DormBunks: PropTypes.number,
    MaxDivers: PropTypes.number,
    DepositDate: PropTypes.string,
    Comment: PropTypes.string,
    Notes: PropTypes.string,
    SendConfirm: PropTypes.number,
    SendReminder: PropTypes.number,
    ReminderSent: PropTypes.number,
    ReminderDate: PropTypes.string,
    HomeChanged: PropTypes.number,
    WebChanged: PropTypes.number,
    SubDealerId: PropTypes.number,
    SubDealerPrice: PropTypes.number,
    hold_72: PropTypes.number,
    PremiumSingle: PropTypes.number,
    PremiumDouble: PropTypes.number,
    PremiumNonDiver: PropTypes.number,
    PremiumShared: PropTypes.number,
    TriStateNonDiver: PropTypes.number,
    TriStateShared: PropTypes.number,
    TriState: PropTypes.number,
    SuperBerths: PropTypes.number,
    HowDidYouHear: PropTypes.string,
    HowDidYouHearOther: PropTypes.string,
    clientname: PropTypes.string,
    clientbookingref: PropTypes.string,
    isTemp: PropTypes.number,
    termsAccepted: PropTypes.number,
    bookDate: PropTypes.string,
    BookOrigin: PropTypes.string,
    Rebooking: PropTypes.number,
    deposit1Date: PropTypes.string,
    deposit2Date: PropTypes.string,
    deposit3Date: PropTypes.string,
    deposit4Date: PropTypes.string,
    finalDate: PropTypes.string,
    deposit1AmountDue: PropTypes.number,
    deposit2AmountDue: PropTypes.number,
    deposit3AmountDue: PropTypes.number,
    deposit4AmountDue: PropTypes.number,
    finalAmountDue: PropTypes.number,
    retailPaymentDue: PropTypes.string,
    balance: PropTypes.number,
    daysToTrip: PropTypes.number,
    tripDate: PropTypes.string,
    tripDestination: PropTypes.string,

    berths: BerthsPropTypes,

    deposit1DueDate: PropTypes.string,
    deposit2DueDate: PropTypes.string,
    deposit3DueDate: PropTypes.string,
    deposit4DueDate: PropTypes.string,
    finalDueDate: PropTypes.string,
    deposit1Total: PropTypes.number,
    deposit2Total: PropTypes.number,
    deposit3Total: PropTypes.number,
    deposit4Total: PropTypes.number,
    dealerPaymentDue: PropTypes.number,
    PaxCount: PropTypes.number,
    finalTotal: PropTypes.number,
    taxRate: PropTypes.number,

    beds: PropTypes.arrayOf(AccommodationPropTypes),
    trip: TripPropTypes,
});